// Section 19: Early frost. 6% per season, Autumn bias. The harvest of the season it strikes is
// 0.8x ("if not harvested by a Summer push": the Summer early harvest is already in, so only the
// main harvest suffers). No choice. Constants: config.events['early-frost'].
import type { Config } from '../../config';
import {
  effectDelta,
  effectParamModifiers,
  eventEntry,
  eventTurn,
} from '../../core/content-helpers';
import { defineEvent } from '../../core/registry';

export function earlyFrost(config: Config) {
  const c = config.events['early-frost'];
  return defineEvent({
    id: 'early-frost',
    label: 'Early frost',
    section: 'S19',
    baseWeight: c.baseChance,
    seasons: ['autumn'],
    foreshadow: null,
    ledgerTag: null,
    weight: () => c.baseChance,
    text: () => eventEntry('early-frost', { mul: c.harvestMul }),
    apply: (ctx) => [
      effectDelta('early-frost', 'harvest', eventTurn(ctx) + 1, 1, { harvestMul: c.harvestMul }),
    ],
    choices: [],
    modifierTargets: ['harvestYield'],
    modifiers: effectParamModifiers,
  });
}
